import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { useIsUserVerified } from 'state/user/hooks'
import { Button, Text, Modal, Flex, IconWrapper } from '@mprolab/uikit'
import { UserCheck } from 'react-feather'
import { StatusBar } from '../components'

interface IVerificationModalProps {
  onVerify: () => Promise<void>
  onDismiss?: () => void
  onVerificationDeclined?: () => void
}

const StyledModalWrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    width: 493px;
  }
`

const VerificationModal: React.FunctionComponent<IVerificationModalProps> = (props) => {
  const { t } = useTranslation()
  const { onVerify, onDismiss = () => null, onVerificationDeclined = () => null } = props
  const theme = useTheme()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [actionTriggered, setActionTriggered] = useState<boolean>(false)
  const isUserVerified = useIsUserVerified()

  const closeModalHandler = () => {
    onVerificationDeclined()
    onDismiss()
  }

  const handleVerification = async () => {
    setIsLoading(true)
    setActionTriggered(true)
    await onVerify()
    setIsLoading(false)
  }

  const getActionComponent = () => {
    return actionTriggered ? (
      <StatusBar isLoading={isLoading} isUserVerified={isUserVerified} />
    ) : (
      <Button
        // eslint-disable-next-line no-return-await
        onClick={async () => await handleVerification()}
        startIcon={<IconWrapper icon={<UserCheck />} mr="8px" />}
      >
        {t('web3Modal.buttonCTA')}
      </Button>
    )
  }

  return (
    <Modal onDismiss={closeModalHandler} title={t('web3Modal.title')}>
      <StyledModalWrapper>
        <Text color={theme.colors.white3}>{t('web3Modal.description')}</Text>
      </StyledModalWrapper>
      <Flex mt="40px" width="100%" justifyContent="center">
        {getActionComponent()}
      </Flex>
    </Modal>
  )
}

export default VerificationModal
